import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global error handler for third-party scripts like PayPal
window.addEventListener('error', (event) => {
  // Check if this is a script error with no detailed info (common for CORS issues)
  if (event.message === 'Script error.' || event.filename === '') {
    console.warn('Caught cross-origin script error. Details limited due to browser security restrictions.');
    // Prevent the error from showing in console
    event.preventDefault();
    return true;
  }
  return false;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
